import React, { useContext, useEffect, useState } from "react";
import ReactBellIcon from "react-bell-icon";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Store } from "../Store";
import {
  getLocalTimeFormatted,
  getTableDescriptionBreef,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import TableDescription from "./TableDescription";
import TableExchange from "./TableExchange";

export default function TableButton(props) {
  const { state } = useContext(Store);
  const [showTableExchange, setShowTableExchange] = useState(false);
  const { carts, users = [], tableTypes = [] } = state;
  const [showEnterDescription, setShowEnterDescription] = useState(false);
  const {
    cartItems,
    cart,
    keyy,
    isSelected,
    tableNum,
    tableMinWitdh,
    setTableTemp,
    setTableSelectedFromMain,
    ctxDispatch,
    marginBottom,
    tableNoMargin,
  } = props;

  const [buttonTableExhangeEnabled, setButtonTableExhangeEnabled] =
    useState(false);
  const [isAlerting, setIsAlerting] = useState(false);
  const [alertMinuteCount, setAlertMinuteCount] = useState();

  useEffect(() => {
    if (cart.alertOn) {
      if (cartItems.length > 0) {
        const lastItemTime = new Date(
          cartItems[cartItems.length - 1].createdAt
        );
        const now = new Date();
        const timeDiffMinutes = (now - lastItemTime) / 60000;

        if (
          timeDiffMinutes > (cart.alertTimePeriod || 30) ||
          alertMinuteCount > (cart.alertTimePeriod || 30)
        ) {
          const alertInterval = setInterval(() => {
            setIsAlerting((prev) => !prev);
          }, 1000);
          return () => clearInterval(alertInterval);
        } else {
          setIsAlerting(false);
        }
      }
    } else {
      setIsAlerting(false);
    }
  }, [cartItems, alertMinuteCount, cart]);

  useEffect(() => {
    if (cart.alertOn ?? true) {
      if (cartItems.length > 0) {
        const alertTimeInterval = setInterval(() => {
          const timeDiff = Math.floor(
            Math.abs(
              new Date() - new Date(cartItems[cartItems.length - 1].createdAt)
            ) /
              (1000 * 60)
          );

          setAlertMinuteCount(timeDiff);
        }, 1000);
        return () => clearInterval(alertTimeInterval);
      }
    }
  }, [cartItems, cart]);

  return (
    <div>
      <Button
        key={keyy}
        size={cartItems.length > 0 || "lg"}
        className={
          (cartItems.length > 0 ? "text-start " : "") +
          (isSelected ? "border border-warning " : "")
        }
        style={{
          minWidth: tableMinWitdh,
          aspectRatio: "1/1",
          margin: tableNoMargin ? "0.3rem" : "0.4rem",
          marginTop: tableNoMargin ? "0.3rem" : "0.0rem",
          marginBottom: tableNoMargin
            ? "0.3rem"
            : marginBottom
            ? marginBottom
            : "0.8rem",
          position: "relative",
          paddingTop: "0px",
          paddingBottom: "0px",
          transition: "background-color 0.5s ease",
        }}
        variant={
          isSelected
            ? "primary"
            : cartItems.length > 0
            ? isAlerting
              ? "danger"
              : "success"
            : "secondary"
        }
        onClick={() => {
          if (buttonTableExhangeEnabled) {
            return;
          }
          setTableTemp(tableNum);
          ctxDispatch({ type: "CLOSE_HISTORIC_MOD" });

          ctxDispatch({
            type: "SELECT_TABLE",
            payload: tableNum,
          });
          setTableSelectedFromMain && setTableSelectedFromMain(true);
        }}
      >
        {cartItems.length > 0 ? (
          <table className="table table-sm  mb-0 pt-0">
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  className={"text-bold  text-warning"}
                  style={{ fontFamily: "monospace" }}
                >
                  <span className="text-dark">{tableNum}</span>
                  &nbsp;
                  {cart &&
                    cart.description &&
                    getTableDescriptionBreef(cart.description)}
                </td>
              </tr>

              {cartItems.length > 0 && (
                <tr className="small-font">
                  <td>{cart.alertOn ?? true ? "Süre" : "Açılış"}</td>
                  <td className={"text-bold"}>
                    {cart.alertOn ?? true ? (
                      <span>
                        {alertMinuteCount > 0
                          ? alertMinuteCount + " dk"
                          : "yeni"}
                      </span>
                    ) : (
                      <span>
                        {getLocalTimeFormatted(
                          cartItems[0].createdAt || cartItems[0].initedAt
                        )}
                      </span>
                    )}
                  </td>
                </tr>
              )}
              <tr className="small-font">
                <td>Toplam:</td>
                <td className={"text-bold"}>
                  {turkishCurrencyFormatterNoPrecision(
                    cartItems
                      .filter((x) => !x.isGift && !x.isPartialPaid)
                      .reduce(
                        (a, c) =>
                          a +
                          c.quantity *
                            (c.feature ? c.feature.price + c.price : c.price) +
                          (c.answers
                            ?.flatMap((a) => a.answers)
                            .filter((a) => a && !a.product)
                            .reduce((a, c) => a + c.cost, 0) || 0),
                        0
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <>
            <Row>
              <Col>
                {cartItems.description ? (
                  <Badge pill bg="danger">
                    {getTableDescriptionBreef(cartItems.description)}
                  </Badge>
                ) : (
                  "Masa"
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Badge pill bg="dark">
                  {tableNum}
                </Badge>
              </Col>
            </Row>
          </>
        )}
        {cartItems.filter(
          (item) =>
            !item.delivered && (item.tableCode || item.clientCode) && item.alert
        ).length > 0 && (
          <div
            className="border border-danger rounded-circle bg-white"
            style={{
              position: "absolute",
              top: -7,
              left: -7,
              width: "35px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ReactBellIcon
              active={false}
              animate={true}
              color="#dc3545"
              width={25}
              height={25}
            />
          </div>
        )}
        {
          <>
            <Link
              to="#"
              variant="secondary"
              className={"p-2 text-white"}
              onMouseOver={() => {
                setButtonTableExhangeEnabled(true);
              }}
              onMouseLeave={() => setButtonTableExhangeEnabled(false)}
              onClick={() => {
                setShowEnterDescription(true);
              }}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
              }}
            >
              <h6>
                <i className="fa fa-file-text-o"></i>
              </h6>
            </Link>

            {cartItems.length > 0 && (
              <Link
                to="#"
                variant="secondary"
                className={"p-2 text-warning"}
                onMouseOver={() => {
                  setButtonTableExhangeEnabled(true);
                }}
                onMouseLeave={() => setButtonTableExhangeEnabled(false)}
                onClick={() => {
                  if (cartItems.length > 0) {
                    setShowTableExchange(true);
                  }
                }}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 27,
                }}
              >
                <h6>
                  <i className="fas fa-exchange-alt"></i>
                </h6>
              </Link>
            )}
          </>
        }

        {cart.cartItems.length > 0 && cart.onBusinessUser && users && (
          <div
            className="text-warning ms-3"
            style={{
              position: "absolute",
              top: "0px",
              left: "-3px",
              fontSize: "12px",
              fontFamily: "monospace",
            }}
          >
            {"•" +
              users
                .find((u) => u._id === cart.onBusinessUser)
                ?.name.substring(0, 7)}
          </div>
        )}

        {cart.tableType &&
          tableTypes &&
          tableTypes
            .filter((tt) => tt.status)
            .find((u) => u._id === cart.tableType) && (
            <div
              className="text-black ms-3"
              style={{
                position: "absolute",
                bottom: "-0px",
                right: "-15px",
                fontSize: "12px",
                fontFamily: "monospace",
              }}
            >
              <img
                src={tableTypes.find((u) => u._id === cart.tableType)?.image}
                alt={tableTypes.find((u) => u._id === cart.tableType)?.name}
                className="me-3"
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "5px",
                  opacity: "0.5",
                }}
              />
            </div>
          )}
      </Button>

      {showEnterDescription && (
        <TableDescription
          showEnterDescription={showEnterDescription}
          setShowEnterDescription={setShowEnterDescription}
          tableNum={tableNum}
          alertTimePeriod={cart.alertTimePeriod}
          onBusinessUser={cart.onBusinessUser}
          alertOn={cart.alertOn}
          description={cart.description}
        />
      )}

      <TableExchange
        carts={carts}
        show={showTableExchange}
        setShow={setShowTableExchange}
        changeThisTableNum={tableNum}
      />
    </div>
  );
}
